import { GetServerSidePropsContext } from 'next'

import ArticlePreview from '@/components/ArticlePreview/ArticlePreview'
import CardLists from '@/components/CardLists/CardLists'
import DefaultHead from '@/components/DefaultHead/DefaultHead'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import Tabs from '@/components/Tabs/Tabs'
import { GenericPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const SetsSubPage = ({ data }: GenericPageProps) => (
  <Main>
    <DefaultHead data={data} />
    <SimpleHeader>{data.header}</SimpleHeader>
    {data.panels?.articles && (
      <div className='d-flex flex-column flex-sm-row gap-2 mb-2'>
        {data.panels?.articles?.map((article) => <ArticlePreview article={article} key={article.href} />)}
      </div>
    )}
    <Tabs />
    <CardLists disabledSortMethods={['percent', 'synergy']} initCardLists={data.container.json_dict.cardlists} />
  </Main>
)

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const replacedSetCode = (context.query.setCode as string).replace('gpt', 'g_pt') // Adblock workaround
  const url = `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/sets/${replacedSetCode}.json`
  return serverSidePropsFor(url)
}

export default SetsSubPage
